<div class="container">
  <div class="text-center justify-content-center">
    <h1 class="fs-3 fw-bold" style="color: #8e0e00">Release Payment</h1>
  </div>
  <div class="row">
    <div class="col-md-9 col-sm-6 d-flex justify-content-start">
      <button class="btn btn-outline-secondary" type="button" ngbTooltip="Export">
        Export
      </button>
      <!-- <button class="btn btn-outline-secondary ms-2" type="button" ngbTooltip="Print">
        Print
      </button> -->
    </div>
    <div class="col-md-3 col-sm-6 d-flex justify-content-end">
      <input type="text" class="form-control" placeholder="Search..." (input)="onSearch($event)" />
    </div>
  </div>

  <div class="card p-3 shadow-lg mt-3">
    <div class="justify-content-start">
      <h5 class="fs-5 fw-bold">Order Details</h5>
    </div>
    <div class="table-responsive" style="overflow-x: auto">
      <table class="table table-bordered table-striped table-hover" style="min-width: 2000px">
        <thead class="thead-dark">
          <tr>
            <!-- <th
              style="width: 300px !important"
              *ngFor="let header of tableHeader"
              class="text-center"
            >
              {{ header }}
            </th> -->

            <th style="width: 300px !important" class="text-center">
              Order ID
            </th>

            <th style="width: 300px !important" class="text-center">
              Individual / Corporate Requestor Name
            </th>

            <th style="width: 300px !important" class="text-center">
              Final Trip Confirmation By Requestor
            </th>

            <th style="width: 300px !important" class="text-center">
              Dumpster Name
            </th>

            <th style="width: 300px !important" class="text-center">
              Dump Yard Name
            </th>

            <th style="width: 300px !important" class="text-center">
              Final trip confirmation by dump yard
            </th>

            <th style="width: 300px !important" class="text-center">
              Dumped Status
              <i
                class="bi bi-funnel"
                id="dumpedStatusDropdown"
                data-bs-toggle="dropdown"
              ></i>

              <ul class="dropdown-menu" aria-labelledby="dumpedStatusDropdown">
                <li (click)="filterData('DUMPED_STATUS', 'All')">
                  <a class="dropdown-item">All</a>
                </li>
                <li
                  *ngFor="let status of uniqueDumpStatus"
                  (click)="filterData('DUMPED_STATUS', status)"
                >
                  <a class="dropdown-item"> {{ status }}</a>
                </li>
              </ul>
            </th>

            <th style="width: 300px !important" class="text-center">
              Container Type

              <i
                class="bi bi-funnel"
                id="dumpedStatusDropdown"
                data-bs-toggle="dropdown"
              ></i>

              <ul class="dropdown-menu" aria-labelledby="dumpedStatusDropdown">
                <li (click)="filterData('DUMPED_STATUS', 'All')">
                  <a class="dropdown-item">All</a>
                </li>
                <li
                  *ngFor="let type of uniqueContainerType"
                  (click)="filterData('CONTAINER_TYPE', type)"
                >
                  <a class="dropdown-item"> {{ type }}</a>
                </li>
              </ul>
            </th>

            <th style="width: 300px !important" class="text-center">
              No of Container
            </th>

            <th style="width: 300px !important" class="text-center">
              Total Trips
            </th>

            <th style="width: 300px !important" class="text-center">
              Actual Trips
            </th>

            <th style="width: 300px !important" class="text-center">
              SAR Received from Requestor
            </th>

            <th style="width: 300px !important" class="text-center">
              SAR allocated to dumpster
            </th>

            <th style="width: 300px !important" class="text-center">
              SAR allocated to dump yard
            </th>

            <th style="width: 300px !important" class="text-center">
              SAR allocated to Smart-Sort
            </th>

            <th style="width: 300px !important" class="text-center">
              SAR Refunded to Requestor
            </th>

            <th style="width: 300px !important" class="text-center">
              Bank Details
            </th>

            <th style="width: 300px !important" class="text-center">
              Order status

              <i
                class="bi bi-funnel"
                id="dumpedStatusDropdown"
                data-bs-toggle="dropdown"
              ></i>

              <ul class="dropdown-menu" aria-labelledby="dumpedStatusDropdown">
                <li>
                  <a
                    class="dropdown-item"
                    (click)="filterData('ORDER_STATUS', 'All')"
                    >All</a
                  >
                </li>
                <li
                  *ngFor="let status of uniqueOrderStatus"
                  (click)="filterData('ORDER_STATUS', status)"
                >
                  <a class="dropdown-item">{{ status }}</a>
                </li>
              </ul>
            </th>

            <th style="width: 300px !important" class="text-center">
              Dumpster Action
            </th>

            <th style="width: 300px !important" class="text-center">
              Dumpyard Action
            </th>

            <th style="width: 300px !important" class="text-center">
              Requestor Action
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of pagedData; let i = index">
            <td (click)="openDetailModal(detailsModal, row)"
              class="pointer text-center custom-width custom-column-width">
              <a class="hyperLink text-center">{{ row.orderId }}</a>
            </td>
            <td class="text-center">{{ row.requestorName }}</td>
            <td class="text-center">{{ row.orderStatus >= 110 ? 'Trips Completed' : 'In Process' }}</td>
            <td class="text-center">{{ row.dumpsterCompanyName }}</td>
            <td class="text-center">{{ row.dumpyardCompanyName }}</td>
            <td class="text-center">{{ row.dumpyarOrderStatus >= 140 ? 'Trips Completed' : 'In Process' }}</td>
            <!-- <td class="text-center">{{ getStatus(row.dumpDisposedStatus) }}</td> -->
            <td class="text-center">{{ row.dumpStatusText }}</td>
            <td class="text-center">{{ row.containerType }}</td>
            <td class="text-center">{{ row.noOfContainer }}</td>
            <td class="text-center">{{ row.totalTrips }}</td>
            <td class="text-center">{{ row.actualTrips }}</td>
            <td class="text-center">{{ row.sarFromRequestor }}</td>
            <td class="text-center">{{ row.dumpsterAmount }}</td>
            <td class="text-center">{{ row.dumpyardAmount }}</td>
            <td class="text-center">{{ row.smartSortAmount }}</td>
            <td class="text-center">
              {{
              row.sarRefundtoRequester === "" ||
              row.sarRefundtoRequester === "0"
              ? "N/A"
              : row.sarRefundtoRequester
              }}
            </td>
            <td class="text-center pointer" style="width: 10%">
              <a class="hyperLink" (click)="openBankDetailsModal(bankDetailsModal, row)">View Bank Details</a>
            </td>
            <td class="text-center" style="width: 10%">
              <span>
                {{
                row.dumpesterOrderStatus === "135" &&
                row.dumpyarOrderStatus === "142" &&
                (row.orderStatus === "111" || row.orderStatus === "113")
                ? "Order Closed"
                : "Order Inprocess"
                }}
              </span>

              <!-- {{ row.orderStatus == 142}} -->
            </td>
            <td [class.disabled]="row.dumpDisposedStatus === false" class="text-center"
              (click)="handlePayment(row, 'dumpster')">
              <a style="color: #8e0e00" class="hyperLink" *ngIf="row.dumpesterOrderStatus !== '135'">Pay</a>
              <span *ngIf="row.dumpesterOrderStatus === '135'" class="d-flex align-items-center badge text-bg-success">
                <span class=""></span> SAR Credited
              </span>
            </td>
            <td [class.disabled]="row.dumpDisposedStatus === false" class="text-center"
              (click)="handlePayment(row, 'dumpyard')">
              <a style="color: #8e0e00" class="hyperLink" *ngIf="row.dumpyarOrderStatus !== '142'">Pay</a>
              <span *ngIf="row.dumpyarOrderStatus === '142'" class="d-flex align-items-center badge text-bg-success">
                <span class=""></span> SAR Credited
              </span>
            </td>
            <td [class.disabled]="
                row.dumpDisposedStatus === false ||
                row.sarRefundtoRequester === '0'
              " class="text-center" (click)="handlePayment(row, 'requestor')">
              <a style="color: #8e0e00" class="hyperLink" *ngIf="row.orderStatus !== '113'">{{
                row.sarRefundtoRequester === "" ||
                row.sarRefundtoRequester === "0"
                ? "N/A"
                : "Pay"
                }}</a>
              <span *ngIf="row.orderStatus === '113'" class="d-flex align-items-center badge text-bg-success">
                <span class=""></span> SAR Credited
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-center align-items-center text-center"
        *ngIf="releasePaymentList?.length === 0">
        <h3>No Data Found</h3>
      </div>
    </div>
    <!-- Pagination -->
    <div class="d-flex justify-content-center mt-2" *ngIf="releasePaymentList?.length > 0">
      <ngb-pagination [(page)]="currentPage" [pageSize]="pageSize" [collectionSize]="releasePaymentList?.length"
        (pageChange)="onPageChange($event)" [maxSize]="3" [boundaryLinks]="true">
      </ngb-pagination>
    </div>
    <div *ngIf="releasePaymentList?.length > 0" class="text-muted text-end mb-3">
      <strong>Showing {{ (currentPage - 1) * pageSize + 1 }} to {{ (currentPage * pageSize) > releasePaymentList?.length ?
        releasePaymentList?.length
        :currentPage *pageSize }} of {{ releasePaymentList?.length }} entries</strong>
    </div>
  </div>

  <!--------------------------------- Confirm popup --------------------------------->

  <ng-template #confirmationModal let-modal>
    <div class="modal-header custom-modal-header">
      <h2 class="modal-title mt-3">Confirm Payment</h2>
      <button type="button" class="btn-close" style="background-color: white !important" aria-label="Close"
        (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
      Are you sure the payment has been distributed to the dumpster & dump yard?
    </div>
    <div class="modal-footer">
      <button type="button" class="btn custom-confirm-btn" (click)="postOrderStatus(modal)">
        Confirm
      </button>
      <button type="button" class="btn custom-cancel-btn" (click)="modal.dismiss('Cancel click')">
        Cancel
      </button>
    </div>
  </ng-template>

  <!--------------------------------- Details popup --------------------------------->

  <ng-template #detailsModal let-modal>
    <div class="modal-header custom-modal-header">
      <h2 class="modal-title mt-3">
        Order Details for OrderId - ( {{ selectedOrderId }} )
      </h2>
      <button type="button" class="btn-close" style="background-color: white !important" aria-label="Close"
        (click)="modal.dismiss('Cross click')"></button>
    </div>
    <form [formGroup]="listForm">
      <div class="modal-body custom-modal" style="max-height: 500px; overflow-y: scroll">
        <!-- User Type Form Group -->
        <div class="mb-3 row">
          <label for="userType" class="col-sm-4 col-form-label text-start">Requestor Type</label>
          <div class="col-sm-8">
            <input id="userType" formControlName="userType" class="form-control" [readonly]="true" />
          </div>
        </div>

        <!-- Company Name Form Group -->
        <div class="mb-3 row">
          <label for="companyName" class="col-sm-4 col-form-label text-start">Name</label>
          <div class="col-sm-8">
            <input id="companyName" formControlName="companyName" class="form-control" />
          </div>
        </div>

        <!-- Mobile Number Form Group -->
        <div class="mb-3 row">
          <label for="mobileNumber" class="col-sm-4 col-form-label text-start">Mobile Number</label>
          <div class="col-sm-8">
            <input id="mobileNumber" formControlName="mobileNumber" class="form-control" type="text" />
          </div>
        </div>

        <!-- Email Form Group -->
        <div class="mb-3 row">
          <label for="city" class="col-sm-4 col-form-label text-start">City</label>
          <div class="col-sm-8">
            <input id="city" formControlName="city" class="form-control" type="city" />
          </div>
        </div>

        <!-- City Form Group -->
        <div class="mb-3 row">
          <label for="zone" class="col-sm-4 col-form-label text-start">Zone</label>
          <div class="col-sm-8">
            <input id="zone" formControlName="zone" class="form-control" />
          </div>
        </div>

        <!-- Zone Form Group -->
        <div class="mb-3 row">
          <label for="requestDate" class="col-sm-4 col-form-label text-start">Requested Date & Time</label>
          <div class="col-sm-8">
            <input id="requestDate" formControlName="requestDate" class="form-control" />
          </div>
        </div>

        <!-- Bank Name Form Group -->
        <div class="mb-3 row">
          <label for="scheduleDate" class="col-sm-4 col-form-label text-start">Scheduled Date & Time</label>
          <div class="col-sm-8">
            <input id="scheduleDate" formControlName="scheduleDate" class="form-control" />
          </div>
        </div>

        <!-- Container Name No Form Group -->
        <div class="mb-3 row">
          <label for="containerType" class="col-sm-4 col-form-label text-start">Container Type</label>
          <div class="col-sm-8">
            <input id="containerType" formControlName="containerType" class="form-control" />
          </div>
        </div>

        <!-- Bank Account No Form Group -->
        <div class="mb-3 row">
          <label for="containerCapacity" class="col-sm-4 col-form-label text-start">Container Capacity</label>
          <div class="col-sm-8">
            <input id="containerCapacity" formControlName="containerCapacity" class="form-control" />
          </div>
        </div>

        <!-- CR Number Form Group -->
        <div class="mb-3 row">
          <label for="noOfContainer" class="col-sm-4 col-form-label text-start">No Of Container</label>
          <div class="col-sm-8">
            <input id="noOfContainer" formControlName="noOfContainer" class="form-control" />
          </div>
        </div>

        <!-- CR Document Form Group -->
        <div class="mb-3 row">
          <label for="rentalDuration" class="col-sm-4 col-form-label text-start">Rental Duration</label>
          <div class="col-sm-8">
            <input id="rentalDuration" formControlName="rentalDuration" class="form-control" />
          </div>
        </div>

        <div class="mb-3 row">
          <label for="sarFromRequestor" class="col-sm-4 col-form-label text-start">SAR received from the
            requestor</label>
          <div class="col-sm-8">
            <input id="sarFromRequestor" formControlName="sarFromRequestor" class="form-control" />
          </div>
        </div>

        <div class="mb-3 row">
          <label for="dumpsterName" class="col-sm-4 col-form-label text-start">Dumpster Name</label>
          <div class="col-sm-8">
            <input id="dumpsterName" formControlName="dumpsterName" class="form-control" />
          </div>
        </div>

        <div class="mb-3 row">
          <label for="crDocument" class="col-sm-4 col-form-label text-start">
            Mobile No</label>
          <div class="col-sm-8">
            <input id="dumpsterMblNo" formControlName="dumpsterMblNo" class="form-control" />
          </div>
        </div>

        <div class="mb-3 row">
          <label for="crDocument" class="col-sm-4 col-form-label text-start">Dump Yard Name</label>
          <div class="col-sm-8">
            <input id="dumpyardName" formControlName="dumpyardName" class="form-control" />
          </div>
        </div>

        <div class="mb-3 row">
          <label for="crDocument" class="col-sm-4 col-form-label text-start">
            Mobile No</label>
          <div class="col-sm-8">
            <input id="dumpyardMblNo" formControlName="dumpyardMblNo" class="form-control" />
          </div>
        </div>
      </div>
    </form>
  </ng-template>

  <!-- Bank Details Modal -->
  <ng-template #bankDetailsModal let-modal>
    <div class="modal-header custom-modal-header">
      <h2 class="modal-title mt-3">
        Bank Details for OrderId - ( {{ selectedIdForBank }} )
      </h2>
      <button type="button" class="btn-close" style="background-color: white !important" aria-label="Close"
        (click)="modal.dismiss('Cross click')"></button>
    </div>
    <form [formGroup]="bankForm">
      <div class="modal-body custom-modal" style="max-height: 500px; overflow-y: scroll">
        <!-- Requestor Bank Details -->
        <h2 class="text-center" style="background-color: #8e0e00; color: white">
          Requestor
        </h2>
        <div class="mb-3 row">
          <label for="requestorBank" class="col-sm-4 col-form-label text-start">
            Bank Name</label>
          <div class="col-sm-8">
            <input id="requestorBank" formControlName="requestorBank" class="form-control" [readonly]="true" />
          </div>
        </div>
        <div class="mb-3 row">
          <label for="requestorIban" class="col-sm-4 col-form-label text-start">IBAN Number</label>
          <div class="col-sm-8">
            <input id="requestorIban" formControlName="requestorIban" class="form-control" [readonly]="true" />
          </div>
        </div>

        <!-- Dumpster Bank Details -->
        <h2 class="text-center" style="background-color: #8e0e00; color: white">
          Dumpster
        </h2>
        <div class="mb-3 row">
          <label for="dumpsterBank" class="col-sm-4 col-form-label text-start">Bank Name</label>
          <div class="col-sm-8">
            <input id="dumpsterBank" formControlName="dumpsterBank" class="form-control" [readonly]="true" />
          </div>
        </div>
        <div class="mb-3 row">
          <label for="dumpsterIban" class="col-sm-4 col-form-label text-start">
            IBAN Number</label>
          <div class="col-sm-8">
            <input id="dumpsterIban" formControlName="dumpsterIban" class="form-control" [readonly]="true" />
          </div>
        </div>

        <!-- Dump Yard Bank Details -->
        <h2 class="text-center" style="background-color: #8e0e00; color: white">
          Dump yard
        </h2>
        <div class="mb-3 row">
          <label for="dumpyardBank" class="col-sm-4 col-form-label text-start">Bank Name</label>
          <div class="col-sm-8">
            <input id="dumpyardBank" formControlName="dumpyardBank" class="form-control" [readonly]="true" />
          </div>
        </div>
        <div class="mb-3 row">
          <label for="dumpyardIban" class="col-sm-4 col-form-label text-start">IBAN Number</label>
          <div class="col-sm-8">
            <input id="dumpyardIban" formControlName="dumpyardIban" class="form-control" [readonly]="true" />
          </div>
        </div>
      </div>
    </form>
  </ng-template>
</div>